import { NextButton } from '@/components/buttons/Buttons';
import { Column } from '@/components/container/Container';
import Spacing from '@/components/container/Spacing';
import { TextBodyLarge } from '@/components/text/Texts';
import AddPaymentModal from '@/modules/billing/components/AddPaymentModal';
import { useState } from 'react';
import '../../onboarding.styles.css';
import AccordionContentLayout from '../AccordionContentLayout';
import { OnboardingStep } from '@/types';
import { useOnboardingState } from '../../engine/onboarding.hooks';

const SetBillingContent = () => {
	const [visible, setVisible] = useState(false);
	const { completeStepMutation } = useOnboardingState();

	const handleCardAdded = () => {
		completeStepMutation.mutate(OnboardingStep.BillingPreferences);
	};

	return (
		<AccordionContentLayout>
			<Column>
				<TextBodyLarge
					className="onboarding-content-body"
					text="Choose your preferred billing and payment methods. You will only be charged for the activity you enable through your programs."
				/>
				<Spacing height="h-[24px]" />
				<NextButton
					id="choose-program-next"
					label="Start"
					width="w-[110px]"
					onClick={() => {
						setVisible(true);
					}}
				/>
			</Column>
			<AddPaymentModal
				visible={visible}
				setVisible={setVisible}
				onCardAdded={handleCardAdded}
			/>
		</AccordionContentLayout>
	);
};

export default SetBillingContent;
